<template>
  <div>
    <section class="ftco-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-lg-10">
            <div class="wrap d-md-flex">
              <div
                class="text-wrap p-4 p-lg-5 text-center d-flex align-items-center order-md-last"
              >
                <div class="text w-100">
                  <h2>eMenu Dashboard</h2>
                </div>
              </div>
              <div class="login-wrap p-4 p-lg-5">
                <div class="d-flex">
                  <div class="w-100">
                    <h3 class="mb-4">Sign In</h3>
                  </div>
                  <div class="w-100">
                    <p class="social-media d-flex justify-content-end">
                      <a
                        href="#"
                        class="social-icon d-flex align-items-center justify-content-center"
                        ><span class="fa fa-facebook"></span
                      ></a>
                      <a
                        href="#"
                        class="social-icon d-flex align-items-center justify-content-center"
                        ><span class="fa fa-twitter"></span
                      ></a>
                    </p>
                  </div>
                </div>
                <form class="signin-form" @submit.prevent="login">
                  <div class="form-group form-floating mb-3">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Email"
                      v-model="email"
                      required
                    />
                    <label class="label" for="name">Email</label>
                  </div>
                  <div class="form-group form-floating mb-3">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="password"
                      required
                    />
                    <label class="label" for="password">Password</label>
                  </div>
                  <div class="form-group">
                    <button
                      type="submit"
                      class="form-control btn btn-primary submit px-3"
                    >
                      Sign In
                    </button>
                  </div>
                  <div class="form-group d-md-flex">
                    <div class="w-50 text-left">
                      <!-- <label class="checkbox-wrap checkbox-primary mb-0">Remember Me
                                                <input type="checkbox" checked>
                                                <span class="checkmark"></span>
                                            </label> -->
                    </div>
                    <div class="w-50 text-md-right">
                      <a href="#">Forgot Password</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/axios";
export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async login() {
      try {
        await axios
          .post("/login", {
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            if (response.data.message === "success") {
              this.$notifications.notify({
                message: "Authentication successfull!!",
                icon: "nc-icon nc-time-alarm",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }

            console.log("status", response.data.status);
            // if(response.data.status === 401) {
            //     this.$notifications.notify(
            //     {
            //         message: response.data.message,
            //         icon: 'nc-icon nc-app',
            //         horizontalAlign: 'right',
            //         verticalAlign: 'top',
            //         type: 'danger'
            //     });
            // }
            console.log("user", response.data.user);
            localStorage.setItem("token", response.data.token);
            // localStorage.setItem(
            //     "roles",
            //     JSON.stringify(response.data.user.roles)
            // );
            // localStorage.setItem(
            //     "permissions",
            //     JSON.stringify(response.data.user.permissions)
            // );
            this.$store.dispatch("user", response.data.user);

            setTimeout(() => {
              this.$router.push("/admin");
            }, 1000);
          })
          .catch((error) => {
            console.error("Login error:", error.response.data.message);
            this.$notifications.notify({
              message: error.response.data.message,
              icon: "nc-icon nc-time-alarm",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          });
      } catch (error) {
        // notify.authError(error);
        // if (error.response.data.status === 401) {
        //     this.$toasted
        //         .error(error.response.data.message)
        //         .goAway(4000);
        //         this.$notifications.notify(
        //         {
        //             message: error.response.data.message,
        //             icon: 'nc-icon nc-app',
        //             horizontalAlign: 'right',
        //             verticalAlign: 'top',
        //             type: 'danger'
        //         });
        // }
        console.log("error:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/floating-label.scss";

.form-floating {
  .form-control {
    padding: 1.4rem 1rem;
  }

  > .form-control:focus,
  > .form-control:not(:placeholder-shown),
  > .form-select {
    ~ label {
      color: #fb6440;
      font-weight: 900;
    }
  }
}
</style>
<style scoped>
.ftco-section {
  padding: 7em 0;
}

.heading-section {
  font-size: 28px;
  color: #000;
}

.wrap {
  width: 100%;
  border-radius: 5px;
  -webkit-box-shadow: 0 10px 34px -15px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0 10px 34px -15px rgba(0, 0, 0, 0.24);
  box-shadow: 0 10px 34px -15px rgba(0, 0, 0, 0.24);
}

.login-wrap,
.text-wrap {
  width: 50%;
}

@media (max-width: 991.98px) {
  .login-wrap,
  .text-wrap {
    width: 100%;
  }
}

.text-wrap {
  background: #fb6440;
  background: -moz-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0, #fb6440),
    color-stop(100%, #f2a22a)
  );
  background: -webkit-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -o-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -ms-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -webkit-linear-gradient(315deg, #fb6440 0, #f2a22a 100%);
  background: -o-linear-gradient(315deg, #fb6440 0, #f2a22a 100%);
  background: linear-gradient(135deg, #fb6440 0, #f2a22a 100%);
  color: #fff;
}

.text-wrap .text h2 {
  font-weight: 900;
  color: #fff;
}

.login-wrap {
  position: relative;
  background: #fff;
}

.login-wrap h3 {
  font-weight: 300;
}

.form-group {
  position: relative;
}

.form-group .label {
  font-size: 13px;
  letter-spacing: 1px;
  color: #3c3c3c;
  font-weight: 700;
}

.form-group a {
  color: gray;
}

.form-control {
  height: 48px;
  background: rgba(0, 0, 0, 0.05);
  color: #000;
  font-size: 16px;
  border-radius: 50px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid transparent;
  padding-left: 20px;
  padding-right: 20px;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.form-control::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control::-moz-placeholder {
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:-moz-placeholder {
  color: rgba(0, 0, 0, 0.2) !important;
}

.form-control:active,
.form-control:focus {
  outline: 0 !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.07);
  border-color: transparent;
}

.social-media {
  position: relative;
  width: 100%;
}

.social-media .social-icon {
  display: block;
  width: 40px;
  height: 40px;
  background: 0 0;
  border: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 16px;
  margin-right: 5px;
  border-radius: 50%;
}

.social-media .social-icon span {
  color: #999;
}

.social-media .social-icon:focus,
.social-media .social-icon:hover {
  background: #fb6440;
}

.social-media .social-icon:focus span,
.social-media .social-icon:hover span {
  color: #fff;
}

.checkbox-wrap {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-wrap input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
}

.checkmark:after {
  content: "\f0c8";
  font-family: FontAwesome;
  position: absolute;
  color: rgba(0, 0, 0, 0.1);
  font-size: 20px;
  margin-top: -4px;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .checkmark:after {
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
  }
}

.checkbox-wrap input:checked ~ .checkmark:after {
  display: block;
  content: "\f14a";
  font-family: FontAwesome;
  color: rgba(0, 0, 0, 0.2);
}

.checkbox-primary {
  color: #fb6440;
}

.checkbox-primary input:checked ~ .checkmark:after {
  color: #fb6440;
}

.btn {
  cursor: pointer;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  font-size: 15px;
  padding: 10px 20px;
  border-radius: 50px;
}

.btn:active,
.btn:focus,
.btn:hover {
  outline: 0;
}

.btn.btn-primary {
  background: #fb6440;
  border: 1px solid #fb6440;
  color: #fff;
  background: #fb6440;
  background: -moz-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0, #fb6440),
    color-stop(100%, #f2a22a)
  );
  background: -webkit-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -o-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -ms-linear-gradient(-45deg, #fb6440 0, #f2a22a 100%);
  background: -webkit-linear-gradient(315deg, #fb6440 0, #f2a22a 100%);
  background: -o-linear-gradient(315deg, #fb6440 0, #f2a22a 100%);
  background: linear-gradient(135deg, #fb6440 0, #f2a22a 100%);
}

.btn.btn-primary:hover,
.btn.btn-primary:focus {
  border: 1px solid #fb6440;
  background: #fb6440;
  color: #fff;
}

.btn.btn-primary.btn-outline-primary {
  border: 1px solid #fb6440;
  background: 0 0;
  color: #fb6440;
}

.btn.btn-primary.btn-outline-primary:hover {
  border: 1px solid transparent;
  background: #fb6440;
  color: #fff;
}

.btn.btn-white {
  background: #fff;
  border: 1px solid #fff;
  color: #fff;
}

.btn.btn-white:hover {
  border: 1px solid #fff;
  background: 0 0;
  color: #fff;
}

.btn.btn-white.btn-outline-white {
  border: 1px solid #fff;
  background: 0 0;
  color: #fff;
}

.btn.btn-white.btn-outline-white:hover {
  border: 1px solid transparent;
  background: #fff;
  color: #000;
}
</style>
